module.exports = __webpack_public_path__ + "img/logo.c5c49617.svg";